<template>
	<div class="inline-table-view">
		<div class="header" :style="_col_style">
			<div v-for="(col, i) in columns" :key="`hc${i}`" class="col" :style="{ textAlign: col.align ? col.align : 'left' }">{{ col.label }}</div>
			<div class="col"></div>
		</div>
		<div class="body">
			<div class="row" v-for="(item, j) in _value" :key="`r${j}`" :style="_col_style">
				<div v-for="(col, i) in columns" :key="`rc${i}`" class="col" :style="{ textAlign: col.align ? col.align : 'left' }"><slot :name="col.name" :item="item" /></div>
				<div v-if="j < value.length" class="col" style="text-align: right; cursor: pointer;" @click="del(j)">Slet</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			columns: {
				type: Array,
				default() {
					return [];
				}
			},
			value: {
				type: Array,
				default() {
					return [];
				}
			},
			blank: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		data() {
			return {
				blReady: false,
				bl: null
			};
		},
		watch: {
			bl: {
				handler() {
					console.log('bl', this.bl, this.blank);

					if (!this.blReady) {
						this.blReady = true;
						return;
					}

					// Filter for security (for some reason it takes fields from other components)
					var r = {};

					for (var key in this.blank) {
						r[key] = this.bl[key] || this.blank[key];
					}

					this.$emit('input', this.value.concat(r));

					this.blReady = false;
					this.bl = {...this.blank};
				},
				deep: true
			}
		},
		computed: {
			_col_style() {
				return {
					gridTemplateColumns: this.columns.map((col) => { return col.weight ? col.weight : '1fr' }).join(' ') + ' 60px'
				};
			},
			_value: {
				get() {
					console.log('bl changed', this.bl);
					return this.value.concat(this.bl);
				}
			}
		},
		methods: {
			del(idx) {
				var r = Array.from(this.value);
				r.splice(idx, 1);
				this.$emit('input', r);
			}
		},
		created() {
			this.bl = {...this.blank};
		}
	}
</script>

<style lang="scss" scoped>
	.inline-table-view {
		& > .header {
			display: grid;
			border-bottom: 1px solid #e9e9e9;
			
			& > .col {
				overflow: hidden;
				min-width: 0;
				line-height: 30px;
				height: 30px;
				padding: 0 10px 0 10px;
			}
		}

		& > .body {
			& > .row {
				display: grid;
				border-bottom: 1px solid #e9e9e9;
				column-gap: 1px;

				& > .col {
					min-width: 0;
					line-height: 40px;
					height: 40px;

					& > * {
						height: 100%;
						width: 100%;
						padding: 0 10px 0 10px;
					}

					& input {
						text-align: inherit;
					}
				}

				&:last-child {
					border-bottom: none;

					& > .col {
						background-color: #eeeeee;
					}

					& input {
						background: none;
					}
				}
			}
		}
	}
</style>